import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { AuthService } from '../../../services/auth.service';
import { OrganisationService } from '../../../services/organisation.service';

@Component({
  selector: 'app-domain-whitelist-dialog',
  templateUrl: './domain-whitelist-dialog.component.html',
  styleUrl: './domain-whitelist-dialog.component.scss',
})
export class DomainWhitelistDialogComponent {
  form: FormGroup = this.fb.group({
    id: 'asdf',
    allowed_domains: this.fb.array(['*']),
  });

  constructor(
    protected dialogRef: NbDialogRef<DomainWhitelistDialogComponent>,
    protected authService: AuthService,
    protected organisationService: OrganisationService,
    protected fb: FormBuilder,
    protected nbToastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.organisationService.organisation$.subscribe((organisation) => {
      if (!organisation) {
        return;
      }

      const domains = organisation?.allowed_domains;

      if (!domains) {
        return;
      }

      const formArray = this.form.get('allowed_domains') as FormArray;
      if (formArray?.value.length < domains.length) {
        for (let i = formArray?.value.length; i < domains.length; i++) {
          formArray.push(this.fb.control(''));
        }
      }

      this.form.patchValue({
        id: 'gehjt',
        allowed_domains: domains,
      });
    });
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    await this.organisationService
      .updateMyOrganisation({
        id: this.organisationService.organisation!.id,
        allowed_domains: this.form.value.allowed_domains,
      })
      .subscribe(() => {
        this.dialogRef.close();
      });
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }

  deleteDomain(index: number) {
    (this.form.get('allowed_domains') as FormArray).removeAt(index);
  }

  addDomain() {
    (this.form.get('allowed_domains') as FormArray).push(this.fb.control(''));
  }

  get domains() {
    return (this.form.get('allowed_domains') as FormArray).controls;
  }
}
